// src/events/trade/provider.ts
import { BaseEvent } from "@/domain/event";
import { EventViewModel } from "@/event-core/types";
import { fetchCryptoEventDetail } from "./api";

export async function cryptoViewModelProvider(
    event: BaseEvent,
): Promise<EventViewModel> {
    const data = await fetchCryptoEventDetail( event.eventNo );
    return {
        eventCategory: event.eventCategory,
        eventNo: event.eventNo,
        ...data,
    };
}
